import React from "react";
import { connect } from "react-redux";


import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Button,
	Modal,
	TreeSelect,
	Spin,
	message,

	Icon,

	Popover,
	Form,
	Input,
	Select,

	DatePicker,
	TimePicker

} from 'antd';
import {
	fetchCrewRosteringList, fetchAttendanceList,
	updateCrewRostering, exportCrewRostering, fetchAttendanceSchedule,updateSchedule
} from '../../actions/attendance-actions';
// import crewRosteringListService from "../../services/Attendance/crew-rostering-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
const dateFormat = "YYYY-MM-DD";

const { TreeNode } = TreeSelect;

class AttendanceRecord extends React.Component {
	componentWillMount() {
		this.props.fetchCrewRosteringList();
	}

	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}

	componentDidMount() {
		this._fetchAttendanceList()
		this._fetchAttendanceSchedule()
		this._fetchDepartmentsList()
		// console.log(this.props);
	}
	_fetchAttendanceList = () => {
		this.props.fetchAttendanceList()
	}
	_fetchAttendanceSchedule = () => {
		this.props.fetchAttendanceSchedule()
	}
	_fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
	}
	column = [
		{ title: "工号", key: "job_number", dataIndex: "job_number", className: 'table-global-head-small' },
		{ title: "中文名", key: "real_name", dataIndex: "real_name", className: 'table-global-head-small' },
		{ title: "英文名", key: "english_name", dataIndex: "english_name", className: 'table-global-head' },
		{ title: "部门名称", key: "department_name", dataIndex: "department_name", className: 'table-global-head' },
		{ title: "上班日期", key: "attendance_date", dataIndex: "attendance_date", className: 'table-global-head-small' },
		{
			title: "班次名称", key: "schedule_str", dataIndex: "schedule_str", className: 'table-global-head',
			render: (text) => (
				<span>
					{text === "休息日" ?
						<span style={{ color: "#ff0000" }}>
							{text}
						</span>
						:
						<span>
							{text}
						</span>}
				</span>
			)
		},
		{
			title: "操作", key: "action", dataIndex: "action", className: 'table-global-head-small', render: (text, record, index) => this.props.access.crewRostering.u_value &&
				<Button icon="edit" size="small" className="row-action-btn" onClick={this.updateCurrent.bind(this, index)}>编辑</Button>
		}
	]
	state = {
		currentModalStatus: false,
		currentScheduleModalStatus: false,
		start_date: "",
		end_date: "",
		real_name: null
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
	}

	closeCurrentScheduleModal = () => {
		this.setState({ currentScheduleModalStatus: false });
	}
	submitCurrentModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let posts = {
					// ...values
					...this.state.currentData
				};
				// console.log(values);
				if (null !== this.state.currentIndex) {
					posts.id = this.state.currentData.id;
					posts.attendance_day = this.state.currentData.attendance_day;
					posts.attendance_month = this.state.currentData.attendance_month;
					posts.attendance_year = this.state.currentData.attendance_year;
					posts.schedule_id = this.crewRosteringId;
					console.log(posts);
					// console.log(this.fetchAttendanceTemplateContent);
					this.props.updateCrewRostering(posts, this.state.currentIndex, status => {
						this.setEmployeeFilter();
						if (status) {
							message.success("修改排班管理成功", 4);
						} else {
							message.error("修改排班管理失败", 4);
						}
					});
				}
				this.closeCurrentModal();
			}
		})
	}
	submitCurrentScheduleModal = () => {
		let posts = {
			// ...values

		};
		// submit
		this.props.form.validateFields((err, values) => {
			values.start_time=values.start_time.format('HH:mm');
			values.end_time=values.end_time.format('HH:mm');
			this.props.updateSchedule(values,  status => {
				this.setEmployeeFilter();
				if (status) {
					message.success("批量修改排班成功", 4);
				} else {
					message.error("批量排班管理失败", 4);
				}
			});
			this.closeCurrentScheduleModal();

		})
	}
	updateCurrent = index => {
		this.setState({ currentModalStatus: true });
		// update
		this.setState({ currentData: this.props.attendance.crewRosteringData[index] });
		this.setState({ currentIndex: index });
		// console.log(this.props.attendance.attendanceData[index]);
		// console.log(index);
		this.fetchCrewRosteringContent = this.props.attendance.crewRosteringData[index].schedule_str
		this.crewRosteringId = this.props.attendance.crewRosteringData[index].sequence

	}
	adjustSchedule = () => {
		this.setState({ currentScheduleModalStatus: true });
	}


	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		}
	}
	fetchPageCrewRosteringList = pagination => {
		this.setState({page:pagination.current});
		// console.log(pagination);
		let params = {
			page: pagination.current
		}
		let gets = {};
		for (let key in this.state) {
			if (this.state[key] !== undefined) {
				gets[key] = this.state[key];
			}
		}
		gets = { ...gets, ...params }
		this.props.fetchCrewRosteringList(gets);
	}

	exportCrewRosteringModal() {
		// let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});	
		let export_date = this.state.export_date
		let params = {
			// export_date: this.state.export_date
		}
		if (export_date) {
			export_date = export_date.replace(/-/g, '/')

		}
		else {
			message.error('年月不能为空', 4);
		}

		let date = new Date(export_date)
		// console.log(date);
		params.attendance_year = (`${date.getFullYear()}`)
		params.attendance_month = (`${date.getMonth() + 1}`)
		// console.log(params);
		this.props.exportCrewRostering(params)
		// crewRosteringListService.exportTemplate((params,res) => {
		// 	ref.destroy();
		// 	if (res.data.Success) {
		// 		window.open(res.data.Message);
		// 	} else {
		// 		message.error('下载失败', 4);
		// 	}
		// }, err => {
		// 	ref.destroy();
		// 	message.error('下载失败', 4);
		// });
	}
	setMonthFilter = (val) => {
		// console.log(val);
		if (val) {
			val = val.format(dateFormat)
			this.setState({ export_date: val });
		}
		else {
			this.setState({ export_date: '' });
		}
	}

	handleDatePickerEndChange = (val) => {
		// console.log(val);
		if (val) {
			val = val.format(dateFormat)
		}
		// console.log(val);
		this.setState({ end_date: val });
	}
	handleDatePickerStartChange = (val) => {
		if (val) {
			val = val.format(dateFormat)
		}
		this.setState({ start_date: val });
	}
	setRealNameFilter = event => {
		this.setState({
			real_name: event.target.value
		});
		console.log(this.state.real_name);
	}
	setEmployeeFilter = (value) => {
		this.setState({
			// real_name: value
			//employee_id: value
			// ,job_number: value
		}, () => {
			let gets = {
				//start_date: this.state.start_date,
				search_start_time: this.state.start_date,
				//end_date: this.state.end_date
				search_end_time: this.state.end_date,

				department_id: this.state.department_id,
				page:this.state.page
			}
			if (this.state.real_name) {
				gets.real_name = this.state.real_name;
			}
			// if (this.state.employee_id) {
			//   gets.employee_id = this.state.employee_id;
			// }
			// if (this.state.job_number) {
			//   gets.job_number = this.state.job_number;
			// }
			this.setState(gets);
			this.props.fetchCrewRosteringList(gets)
		})
	}
	// templateChange=(index,value)=>{
	// 	// console.log(index)
	// 	let templateSelectValue = value
	// 	this.crewRosteringId = value
	// 	// console.log(this.props.attendance.attendanceSchedulesData);
	// 	this.props.attendance.attendanceData.forEach(data => {
	// 		// console.log(data);
	// 		if(data.sequence===templateSelectValue){
	// 			this.fetchCrewRosteringContent=(
	// 				<div>{data.on_time} - {data.off_time}</div>
	// 			)
	// 		}
	// 		if(0 === templateSelectValue){
	// 			this.fetchCrewRosteringContent=(
	// 				<div>
	// 					<p>休息日</p>
	// 				</div>
	// 			)
	// 		}
	// 	})
	// }
	changeSchedule = value => {
		// console.log(value);

		this.props.fetchAttendanceSchedule({ search_text: value })

	}
	// searchSchedule = value => {
	// 	console.log(value);

	// 		this.props.fetchAttendanceSchedule({search_text: value})

	// }
	selectSchedule = (value) => {
		// console.log(value);
		let templateSelectValue = value
		this.crewRosteringId = value
		if ("0" === templateSelectValue) {
			this.fetchCrewRosteringContent = (
				<div>
					休息日
				</div>
			)
		} else {
			this.props.attendance.attendanceTemplate.schedules.forEach((item) => {
				// console.log(item.sequence);
				if ((`${item.sequence}`) === templateSelectValue) {
					this.fetchCrewRosteringContent = (
						<div>{item.on_time} - {item.off_time}</div>
					)
				}

			})
		}
	}

	onSelectTreeChange(id) {
		// let params = {
		//     department_id: id
		// }
		// let gets = {};
		// for (let key in this.state) {
		//     if (this.state[key] !== undefined) {
		//         gets[key] = this.state[key];
		//     }
		// }
		// gets = { ...gets, ...params }
		// this.setState(params);
		// this.props.fetchAttendanceSchedule(gets)
		this.setState({
			department_id: id
		});
	}

	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}

	render() {
		const { departmentsList } = this.props.departmentStructure;
		return (
			<div className="app-module-item">
				<div style={{ marginBottom: "20px" }}>
					{this.props.access.crewRostering.export_value && <div style={{ float: "left", overflow: "hidden" }}>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<DatePicker.MonthPicker onChange={this.setMonthFilter}
								placeholder="请选择导出年月" />
						</div>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.exportCrewRosteringModal.bind(this)}>
								<Icon type="cloud-download-o" />
								<span>导出</span>
							</Button>
						</div>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.adjustSchedule.bind(this)}>
								<Icon type="cloud-download-o" />
								<span>调整排班</span>
							</Button>
						</div>
					</div>}
					<div style={{ float: "right", overflow: "hidden" }}>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<span style={{ marginRight: "5px" }}>日期 : </span>
							<DatePicker onChange={this.handleDatePickerStartChange} />
						</div>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<span style={{ marginRight: "5px" }}> 至 </span>
							<DatePicker onChange={this.handleDatePickerEndChange} />
						</div>
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Input
								placeholder="请选择员工 工号/姓名"
								// onSearch={this.setEmployeeFilter}
								value={this.state.real_name}
								onChange={this.setRealNameFilter}
								defaultValue={this.state.real_name}
								style={{ width: 200 }}
							// defaultValue={null}
							/>
						</div>

						{
							departmentsList ?
								<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
									<TreeSelect style={{ minWidth: "200px" }}
										placeholder="请选择部门"
										showSearch={false}
										autoExpandParent={true}
										dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
										treeDefaultExpandAll
										onChange={this.onSelectTreeChange.bind(this)}>
										{this.renderTreeNodes(departmentsList)}
									</TreeSelect>
								</div>
								:
								<Spin />
						}
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.setEmployeeFilter}>
								<span>查询</span>
							</Button>
						</div>

					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				<Table columns={this.column} dataSource={this.props.attendance.crewRosteringData}
					pagination={{
						total: this.props.attendance.crewRosteringTotalPage,
						defaultCurrent: 1,
						pageSize: this.props.attendance.crewRosteringPageSize,
						current: this.props.attendance.crewRosteringPage
					}}
					scroll={{ x: 600 }}
					onChange={this.fetchPageCrewRosteringList.bind(this)}
					rowKey={(record, index) => index} rowSelection={this.rowSelection} />
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="排班管理"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentModal}>
					<div style={{ textAlign: "center" }}>
						{this.state.currentData &&
							<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
								<div>
									<Form.Item label="员工姓名" className='attendance-template'>
										<Input style={{ width: "300px" }} disabled={true}
											value={this.state.currentData.real_name} />
									</Form.Item>
								</div>
								<div>
									<Form.Item label="上班日期" className='attendance-template'>
										<Input style={{ width: "300px" }} disabled={true}
											value={this.state.currentData.attendance_date} />
									</Form.Item>
								</div>
								<div>
									<Form.Item label="模版班次" className='attendance-template'>
										<Popover placement="bottomRight" content={this.fetchCrewRosteringContent}>
											{this.props.form.getFieldDecorator('schedule_str', {
												rules: [{ required: true, message: '请选择考勤班次' }],
												initialValue: this.state.currentData ? this.state.currentData.schedule_str : ""
											})(
												<Select style={{ width: '300px' }}
													mode="combobox"
													filterOption={false}
													onChange={this.changeSchedule}
													// onSearch={this.searchSchedule}
													onSelect={this.selectSchedule}>
													<Select.Option key={false} value="0">休息日</Select.Option>
													{this.props.attendance.attendanceTemplate.schedules && this.props.attendance.attendanceTemplate.schedules.map(v => (
														<Select.Option key={v.sequence} value={v.sequence + ""}>
															{v.on_time + "-" + v.off_time}
														</Select.Option>
													))
													}
												</Select>)}</Popover>
									</Form.Item>
									{/*<Form.Item label="模版班次" className='attendance-template'>
									<Popover placement="bottomRight" content={this.fetchCrewRosteringContent}>
									{this.props.form.getFieldDecorator('schedule_str', {
										rules: [{ required: true, message: '请选择考勤班次' }],
										initialValue: this.state.currentData.schedule_str
									})(
									<Select style={{width:'300px'}} 
									onChange={this.templateChange.bind(this,0)}>
										<Select.Option key={false} value={0}>休息日</Select.Option>
									{this.props.attendance.attendanceData.map(v=>(
										<Select.Option key={v.sequence} value={v.sequence}>
											{v.on_time+"-"+v.off_time}
										</Select.Option>
										))	
									}
									</Select>)}</Popover>
								</Form.Item>*/}
								</div>
							</Form>}
					</div>
				</Modal>
				<Modal width="600px"
					visible={this.state.currentScheduleModalStatus}
					title="修改班次"
					destroyOnClose={true}
					onCancel={this.closeCurrentScheduleModal}
					onOk={this.submitCurrentScheduleModal}>
					<div style={{ textAlign: "left" }}>
						<Form onSubmit={this.submitCurrentScheduleModal} className="login-form" layout="inline">
							<div>

								<Form.Item label="部门">
									{departmentsList && this.props.form.getFieldDecorator("department_ids", {})(
										<TreeSelect style={{ width: "230px" }}
											allowClear
											placeholder="请选择部门"
											showSearch={false}
											autoExpandParent={true}
											dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
											multiple={true}
											treeDefaultExpandAll>
											{this.renderTreeNodes(departmentsList)}
										</TreeSelect>

									)}
								</Form.Item>
							</div>
							<div>
								<Form.Item label="开始日期" className='attendance-template'>
									{this.props.form.getFieldDecorator("schedule_start_date", {})(
										<DatePicker style={{ width: "230px" }} />
									)}
								</Form.Item>
							</div>
							<div>
								<Form.Item label="结束日期" className='attendance-template'>
									{this.props.form.getFieldDecorator("schedule_end_date", {})(
										<DatePicker style={{ width: "230px" }} />
									)}
								</Form.Item>
							</div>
							<div>
							<Form.Item label="开始时间" className='attendance-template'>
							{this.props.form.getFieldDecorator('start_time', {})(<TimePicker minuteStep={30}  format="HH:mm" style={{width:"230px"}} />)}
								</Form.Item>
							</div>
							<div>
							<Form.Item label="结束时间" className='attendance-template'>
							{this.props.form.getFieldDecorator('end_time', {})(<TimePicker minuteStep={30} format="HH:mm" style={{width:"230px"}} />)}
								</Form.Item>
							</div>
						</Form>
					</div>
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		attendance: state.attendance,
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchCrewRosteringList,
	fetchAttendanceList,
	updateCrewRostering,
	exportCrewRostering,
	fetchAttendanceSchedule,
	fetchDepartmentsList,
	updateSchedule
}


AttendanceRecord = Form.create()(AttendanceRecord);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceRecord));











// WEBPACK FOOTER //
// ./src/routes/Attendance/CrewRostering.js